module.exports = __webpack_public_path__ + "media/images/star-half-71214a095678e5139fc32ad7431a74d2.png";